import React from 'react';
import { Container as ContainerBootstrap } from 'react-bootstrap';

import mapModifiers from 'utils/functions';

interface ContainerProps {
  fullWidth?: boolean;
  children?: React.ReactNode;
}

const Container: React.FC<ContainerProps> = ({ children, fullWidth }) => (
  <ContainerBootstrap className={mapModifiers('o-container', fullWidth && 'full')}>{children}</ContainerBootstrap>
);

Container.defaultProps = {
  children: undefined,
};

export default Container;
